import React from 'react';

const Components = React.lazy(() => import('./components'));

export const componentsConfigs = [
  {
    path: '/components',
    element: <Components />,
  },
];